import ToolbarAction from './ToolbarAction';

export default ToolbarAction;
